/* eslint no-console:0 */
import "trix"
import "@rails/actiontext"
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
